export const Components = {
    uploadimage: {
        mainimageContainer:{
            width: '117px',
            height: '52px',
            position: "relative",
            background: '#ecf3ec',
            margin: '3px',
            marginTop: '11px',
            borderRadius: '7px',
            display: 'flex',
            flexDirection: 'column',
            alignContent: 'center',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#a4d3a6',
        },
        file:{
            opacity:'0',
            position: 'absolute',
            width: '100%',
            height: '100%',
            zIndex: '2'
        },
        text:{
            position: 'absolute',
            opacity: '0',
            zIndex: '1',
            left: '45%',
        },
        imagePreviewContainer:{
            position: 'relative',
            width: 'fit-content',
            marginTop: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',

            '&:before': {
                content: '""',
                width: '100%',
                height: '100%',
                background: 'black',
                background: '#0000003b',
                position: 'absolute',
                borderRadius: '11px'
            }
        },
        previewImage:{
            
        },
        button:{
            position: 'absolute'
        },
        imagePreviewmain:{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignContent: 'center',
            justifyContent: 'center',
            width: 'fit-content',
            alignItems: 'center'
        }
    },
    teacherreoprt:{
        image:{
                width:'90%',
                height:'90%',
                borderRadius: '0% !important',
                marginRight: '10%',
                maxWidth: '100px',
                maxHeight: '100px',
        }
    }
}